import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01eaa2b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center ga-2 mb-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "Circuitos", -1))
const _hoisted_3 = { class: "text-caption text-medium-emphasis mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-wrap ga-2 mb-3"
}
const _hoisted_5 = {
  key: 1,
  class: "text-body-2 text-medium-emphasis mb-3"
}
const _hoisted_6 = { class: "d-flex align-center ga-2" }

import { computed, ref, onMounted } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import {
  addTorneoToCircuitoAsync,
  deleteCircuitoTorneoAsync,
  getCircuitosAsociadosATorneoAsync,
  getCircuitosNoTorneoAsync,
} from "@/services/CircuitosService";
import { AddCircuitoTorneoDTO, CircuitoDTO } from "@/interfaces/Circuito";
import { textosEvento } from "@/Constant/FormatoTorneo";
import { esCircuitoAmonSul } from "@/utils/circuitoAmonSul";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardAddTorneoCircuito',
  props: {
    idTorneo: {},
    formato: {}
  },
  setup(__props: any) {

const props = __props;

// Los textos hablan del tipo de evento: torneo, liga o copa
const textos = computed(() => textosEvento(props.formato));
const capitalizar = (texto: string) => texto.charAt(0).toUpperCase() + texto.slice(1);

const circuitosDisponibles = ref<CircuitoDTO[]>([]);
const circuitosAsociados = ref<CircuitoDTO[]>([]);
const isGenerating = ref(false);
const showErrorModal = ref(false);
const showSuccessModal = ref(false);
const mensajeExito = ref("");
const circuitoSelected = ref<CircuitoDTO | null>(null);
const showQuitar = ref(false);
const circuitoQuitar = ref<CircuitoDTO | null>(null);

// Los más nuevos primero
const masNuevoPrimero = (a: CircuitoDTO, b: CircuitoDTO) =>
  b.idCircuito - a.idCircuito;

const cargarCircuitos = async () => {
  try {
    const [noAsociadosRes, asociadosRes] = await Promise.all([
      getCircuitosNoTorneoAsync(props.idTorneo),
      getCircuitosAsociadosATorneoAsync(props.idTorneo),
    ]);

    // A un Amon Sûl no se añade a mano: cada evento va solo al de su año
    circuitosDisponibles.value = [...noAsociadosRes.data]
      .filter((c: CircuitoDTO) => !esCircuitoAmonSul(c.nombreCircuito))
      .sort(masNuevoPrimero);
    circuitosAsociados.value = [...asociadosRes.data].sort(masNuevoPrimero);
  } catch (error) {
    console.error("Error al cargar circuitos:", error);
    showErrorModal.value = true;
  }
};

const confirmar = async () => {
  if (!circuitoSelected.value || props.idTorneo === 0) return;

  try {
    isGenerating.value = true;

    const request: AddCircuitoTorneoDTO = {
      idCircuito: circuitoSelected.value.idCircuito,
      idTorneo: props.idTorneo,
    };

    await addTorneoToCircuitoAsync(request);
    mensajeExito.value = `${capitalizar(textos.value.el)} se ha añadido a ${circuitoSelected.value.nombreCircuito}.`;
    showSuccessModal.value = true;
    circuitoSelected.value = null;
    await cargarCircuitos();
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
  }
};

function pedirQuitar(circuito: CircuitoDTO) {
  circuitoQuitar.value = circuito;
  showQuitar.value = true;
}

const quitar = async () => {
  showQuitar.value = false;
  if (!circuitoQuitar.value) return;
  try {
    isGenerating.value = true;
    await deleteCircuitoTorneoAsync(props.idTorneo, circuitoQuitar.value.idCircuito);
    await cargarCircuitos();
  } catch (error) {
    console.error("Error al eliminar circuito del torneo", error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
  }
};

onMounted(async () => {
  if (props.idTorneo !== 0) {
    await cargarCircuitos();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      variant: "outlined",
      class: "pa-3 text-left circuitos"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_icon, {
            icon: "mdi-trophy-outline",
            color: "primary"
          }),
          _hoisted_2
        ]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(capitalizar(textos.value.el)) + " suma para la clasificación de los circuitos en los que esté. Al Amon Sûl de su año va solo y no se quita. ", 1),
        (circuitosAsociados.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(circuitosAsociados.value, (circuito) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: circuito.idCircuito,
                  color: "primary",
                  variant: "tonal",
                  "prepend-icon": "mdi-trophy"
                }, {
                  append: _withCtx(() => [
                    (_unref(esCircuitoAmonSul)(circuito.nombreCircuito))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          icon: "mdi-lock",
                          size: "small",
                          class: "ms-1",
                          "aria-label": `${circuito.nombreCircuito}: no se puede quitar`
                        }, null, 8, ["aria-label"]))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          icon: "mdi-close-circle",
                          size: "small",
                          class: "ms-1",
                          role: "button",
                          "aria-label": `Quitar de ${circuito.nombreCircuito}`,
                          onClick: _withModifiers(($event: any) => (pedirQuitar(circuito)), ["stop"])
                        }, null, 8, ["aria-label", "onClick"]))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(circuito.nombreCircuito) + " ", 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, " Aún no está en ningún circuito. ")),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_autocomplete, {
            modelValue: circuitoSelected.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((circuitoSelected).value = $event)),
            items: circuitosDisponibles.value,
            "item-title": "nombreCircuito",
            "return-object": "",
            label: "Añadir a un circuito",
            variant: "outlined",
            density: "comfortable",
            "prepend-inner-icon": "mdi-magnify",
            "hide-details": "",
            clearable: "",
            "no-data-text": "No quedan circuitos por añadir",
            disabled: circuitosDisponibles.value.length === 0,
            class: "flex-grow-1"
          }, null, 8, ["modelValue", "items", "disabled"]),
          _createVNode(_component_v_btn, {
            icon: "mdi-plus",
            color: "primary",
            variant: "tonal",
            "aria-label": "Añadir al circuito",
            disabled: isGenerating.value || !circuitoSelected.value,
            onClick: confirmar
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showQuitar.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showQuitar).value = $event)),
      "max-width": "420"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-wrap" }, {
              default: _withCtx(() => [
                _createTextVNode(" ¿Quitar " + _toDisplayString(textos.value.el) + " de " + _toDisplayString(circuitoQuitar.value?.nombreCircuito) + "? ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Dejará de contar para la clasificación de ese circuito. Puedes volver a añadirlo cuando quieras. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showQuitar.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "tonal",
                  onClick: quitar
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Quitar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isGenerating).value = $event)),
      persistent: "",
      width: "200"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-6 d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "60"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: mensajeExito.value,
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "Ha ocurrido un error. Inténtalo de nuevo o contacta al administrador.",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})